import { render } from "./SessionImage.vue?vue&type=template&id=2f896d22"
import script from "./SessionImage.vue?vue&type=script&lang=js"
export * from "./SessionImage.vue?vue&type=script&lang=js"

import "./SessionImage.vue?vue&type=style&index=0&id=2f896d22&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__